
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Receipt } from "lucide-react";
import { PlotExpenseDialog } from "./PlotExpenseDialog";
import { PlotExpenseList } from "./PlotExpenseList";
import { usePlotExpenses } from "@/hooks/usePlotExpenses";

interface PlotExpensesProps {
  plotId: string;
}

export const PlotExpenses = ({ plotId }: PlotExpensesProps) => {
  const { plotExpenses, isLoading, refetchPlotExpenses } = usePlotExpenses(plotId);

  if (isLoading) {
    return (
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Receipt className="mr-2 h-5 w-5" />
            Gastos de la Parcela
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center py-6">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center">
          <Receipt className="mr-2 h-5 w-5" />
          Gastos de la Parcela
        </CardTitle>
      </CardHeader>
      <CardContent className="max-h-[calc(100vh-16rem)]">
        <div className="mb-4">
          <PlotExpenseDialog 
            plotId={plotId} 
            onExpenseCreated={refetchPlotExpenses} 
          />
        </div>
        <PlotExpenseList expenses={plotExpenses} />
      </CardContent>
    </Card>
  );
};
